// Util
import { isValidNumber } from 'libphonenumber-js'
import queryString from 'query-string'
import IntlUtil from './intlutil.jsx'
import usastates from './usastates.jsx'
import { DECIMAL_SEPARATOR, EUROPEAN_COUNTRIES_CODES } from '../../shared/constants.js'
import isEuropeanCountry from '../../shared/util/isEuropeanCountry'

const countries = require('./countries')
const _ = require('lodash')

const demoDescriptions = [
  '<div>Budget & offerte opmaken.</div>',
  '<div>Tussentijdse project bespreking</div>',
  '<div>Afwerking website&nbsp;</div>',
  '<div>afwerking website kopjes en spellings check</div>',
  '<div>Uitwerking huisstijl</div>',
  '<div>prototype ontwerpen</div>'
]

function _getMonth (date) {
  return _getMonthByNumber(date.getMonth())
}

function _getMonthByNumber (monthNo) {
  const shortMonth = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC'
  ]
  return shortMonth[monthNo]
}

function _getFullMonth (date) {
  return _getFullMonthByNumber(date.getMonth())
}

function _getFullMonthByNumber (monthNo) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  return months[monthNo]
}

function _getWeekDay (date) {
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  return days[date.getDay()]
}

function _getDay (date) {
  return date.getDate()
}

function _getYear (date) {
  return date.getFullYear()
}

function _getDateLeft (dueDate) {
  if (!dueDate) {
    return ''
  }

  const currDate = new Date()
  const dueDateObj = new Date(dueDate)
  const diff = Math.abs(currDate.getTime() - dueDateObj.getTime())
  const ago = _getTimeAgo(diff)
  return `${ago} to go`
}

function _getDateLate (dueDate) {
  if (!dueDate) {
    return ''
  }

  const currDate = new Date()
  const dueDateObj = new Date(dueDate)
  const diff = Math.abs(dueDateObj.getTime() - currDate.getTime())
  const ago = _getTimeAgo(diff)
  return `${ago} late`
}

function _removeObjectKey (object, key) {
  if (object[key] !== undefined) {
    delete object[key]
  }

  return object
}

function _removeObjectKeys (object, keys) {
  for (const key of keys) {
    _removeObjectKey(object, key)
  }

  return object
}

function _isValidPhoneNumber (phnNumber) {
  for (const country of EUROPEAN_COUNTRIES_CODES) {
    if (isValidNumber(phnNumber) && isValidNumber(phnNumber, country)) {
      return true
    }
  }

  return false
}

function _targetIsDescendant (event, parent) {
  let node = event.target
  while (node !== null) {
    if (node === parent) return true
    node = node.parentNode
  }
  return false
}

function _getTime (value, defaultVal) {
  const resDate = value && value > 0 ? new Date(value) : null
  if (resDate) {
    let hours = resDate.getHours()
    hours = hours > 9 ? hours : `${hours}`
    let mins = resDate.getMinutes()
    mins = mins > 9 ? mins : `0${mins}`
    return `${hours}:${mins}`
  }

  return defaultVal || ''
}

/* Private functions */
function _getTimeAgo (timeDiff) {
  const hourCount = parseInt(timeDiff / (3600 * 1000))
  const dayCount = parseInt(timeDiff / (24 * 3600 * 1000))
  const weekCount = parseInt(timeDiff / (24 * 3600 * 1000 * 7))
  const monthCount = parseInt(weekCount / 4)
  const yearCount = parseInt(monthCount / 12)

  if (hourCount < 24) {
    return `${hourCount} hours`
  } else if (hourCount < 48) {
    return '1 day'
  } else if (dayCount < 7) {
    return `${dayCount} days`
  } else if (weekCount === 1) {
    return '1 week'
  } else if (weekCount < 4) {
    return `${weekCount} weeks`
  } else if (monthCount === 1) {
    return '1 month'
  } else if (monthCount < 12) {
    return `${monthCount} months`
  } else if (yearCount === 1) {
    return '1 year'
  } else {
    return `${yearCount} years`
  }
}

function _isDateEqual (date1, date2) {
  if (
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear() &&
    date1.getDate() === date2.getDate()
  ) {
    return true
  }

  return false
}

function _convertMinutesToHour (value) {
  if (typeof value === 'number') {
    let hours = Math.floor(value / 60)
    let mins = Math.floor(value % 60)
    if (hours < 10) {
      hours = `${hours}`
    }
    if (mins < 10) {
      mins = `0${mins}`
    }
    return `${hours}:${mins}`
  }

  return '-'
}

function _getTimeDiffInMins (startDate, endDate) {
  const timeStart = startDate.getTime()
  const timeEnd = endDate.getTime()
  const hourDiff = timeEnd - timeStart // in ms
  // const secDiff = hourDiff / 1000; // in s
  const minDiff = hourDiff / 60 / 1000 // in minutes
  const hDiff = hourDiff / 3600 / 1000 // in hours
  const hours = Math.floor(hDiff)
  const mins = minDiff - 60 * hours

  return mins
}

function _formatMoney (value, decPlaces, thouSeparator, decSeparator) {
  decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces
  decSeparator = decSeparator === undefined ? '.' : decSeparator
  thouSeparator = thouSeparator === undefined ? ',' : thouSeparator
  const sign = value < 0 ? '-' : ''
  const i = parseInt((value = Math.abs(+value || 0).toFixed(decPlaces))) + ''
  let j = (j = i.length) > 3 ? j % 3 : 0 // eslint-disable-line
  return (
    sign +
    (j ? i.substr(0, j) + thouSeparator : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSeparator) +
    (decPlaces
      ? decSeparator +
        Math.abs(value - i)
          .toFixed(decPlaces)
          .slice(2)
      : '')
  )
}

function _convertMinutesToTimeText (value) {
  let hours = Math.floor(value / 60)
  let mins = Math.floor(value % 60)
  if (hours < 10) {
    hours = `${hours}`
  }
  if (mins < 10) {
    mins = `0${mins}`
  }

  let timeText =
    hours > 0
      ? `${hours} ${IntlUtil.convertMessage('time.header.labelHours')} `
      : ''
  timeText +=
    mins > 0
      ? `${mins} ${IntlUtil.convertMessage('time.header.labelMinutes')}`
      : ''

  return timeText
}

function _getExtension (fileName) {
  const extInfo = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName) : undefined
  if (extInfo !== undefined && extInfo.length > 0) {
    return extInfo[0].toLowerCase()
  }

  return ''
}

function _getMondayByWeek (year, weekNo) {
  const date = new Date(year, 0, 1 + (weekNo - 1) * 7)
  const day = date.getDay()
  if (day === 1) {
    // If monday
    return date
  }

  const currDate = date.getDate()

  let diff = currDate
  if (day >= 4) {
    diff = currDate - day + (day === 0 ? -6 : 1)
  } else {
    diff = currDate + (1 - day)
  }

  return new Date(date.setDate(diff))
}

function _addDaysToDate (date, incrDays) {
  return new Date(date.getTime() + 1000 * incrDays * 24 * 60 * 60)
}

function _getCountriesFromCode (code) {
  let label = ''
  const matches = countries.filter(country => country.value === code)
  if (matches.length > 0) {
    label = IntlUtil.convertMessage(matches[0].label)
  }

  return label
}

function _isValidPassword (str) {
  const format = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/
  if (format.test(str)) {
    return true
  }

  return false
}

function _getPasswordValidateInfo (str) {
  const info = {
    hasEightChars: str.length >= 8,
    hasAlphaNumeric: /[a-zA-Z]+/.test(str),
    hasDigit: /[0-9]+/.test(str),
    hasNoSpace: str.length > 0 ? !/ /.test(str) : false
  }

  return info
}

function _convertHtmlToText (html) {
  const el = document.createElement('DIV')
  el.innerHTML = html
  return el.textContent || el.innerText || ''
}

function _getTranslatedStatus (status) {
  return `common.status.${status.toLowerCase()}`
}

function _isValidVatNumber (selectedCountry) {
  if (selectedCountry && _.indexOf(EUROPEAN_COUNTRIES_CODES, selectedCountry) >= 0) {
    return true
  }
  return false
}

function _getUrlFromObject (object) {
  if (object) {
    const qryObj = {}
    Object.keys(object).map(key => {
      const fltOption = object[key]
      if (typeof fltOption === 'object') {
        qryObj[key] = JSON.stringify(fltOption)
      } else {
        qryObj[key] = fltOption
      }
    })

    return queryString.stringify(qryObj)
  }

  return ''
}

function _getRandomDescription () {
  const suffleDescriptions = _.shuffle(demoDescriptions)
  return suffleDescriptions[0]
}

function _getUsaStateOptions () {
  return (_.cloneDeep(usastates) || []).sort((a, b) =>
    a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1
  )
}

function _getUsStateFromCode (code) {
  let value = ''
  usastates.forEach(stateObj => {
    if (stateObj.value === code) {
      value = stateObj ? stateObj.label : ''
    }
  })

  return value
}

function _getPdfFileName (type, typeNo, status) {
  const pattern = /[^a-z\-0-9]/gi
  if (status !== 'Draft' && typeNo) {
    return `${type}-${typeNo.replace(pattern, '')}-${
      status ? status.toLowerCase() : ''
    }.pdf`
  }

  return `${type}-${status ? status.toLowerCase() : ''}.pdf`
}

function _getNumberInputSeparators (countryCode) {
  let mappedCountryCode = ''
  // Because of inconsistency of the data in DB the team country code can be one of
  // [
  //   "DE",
  //   "GB",
  //   "NL",
  //   "Netherlands",
  //   "UK",
  //   "US"
  // ]
  switch (countryCode) {
    case 'GB':
      mappedCountryCode = 'UK'
      break
    case 'Netherlands':
      mappedCountryCode = 'NL'
      break
    default:
      mappedCountryCode = countryCode
  }
  const decimalSeparator =
    DECIMAL_SEPARATOR[mappedCountryCode] || DECIMAL_SEPARATOR.NL
  return {
    decimalSeparator,
    thousandSeparator: decimalSeparator === '.' ? ',' : '.'
  }
}

const _calculatePercentage = (numerator, denominator) =>
  numerator && denominator ? Math.round((numerator / denominator) * 100) : 0

const Util = {}
Util.getMonth = _getMonth
Util.getFullMonth = _getFullMonth
Util.getDay = _getDay
Util.getYear = _getYear
Util.getTime = _getTime
Util.getDateLeft = _getDateLeft
Util.getDateLate = _getDateLate
Util.getTimeDiffInMins = _getTimeDiffInMins
Util.removeObjectKey = _removeObjectKey
Util.removeObjectKeys = _removeObjectKeys
Util.isValidPhoneNumber = _isValidPhoneNumber
Util.targetIsDescendant = _targetIsDescendant
Util.isDateEqual = _isDateEqual
Util.convertMinutesToHour = _convertMinutesToHour
Util.formatMoney = _formatMoney
Util.convertMinutesToTimeText = _convertMinutesToTimeText
Util.getWeekDay = _getWeekDay
Util.getExtension = _getExtension
Util.getMondayByWeek = _getMondayByWeek
Util.addDaysToDate = _addDaysToDate
Util.getCountriesFromCode = _getCountriesFromCode
Util.isValidPassword = _isValidPassword
Util.getFullMonthByNumber = _getFullMonthByNumber
Util.getMonthByNumber = _getMonthByNumber
Util.convertHtmlToText = _convertHtmlToText
Util.getTranslatedStatus = _getTranslatedStatus
Util.isEuropeCountry = isEuropeanCountry
Util.isValidVatNumber = _isValidVatNumber
Util.getUrlFromObject = _getUrlFromObject
Util.getPasswordValidateInfo = _getPasswordValidateInfo
Util.getRandomDescription = _getRandomDescription
Util.getUsStateFromCode = _getUsStateFromCode
Util.getUsaStateOptions = _getUsaStateOptions
Util.getPdfFileName = _getPdfFileName
Util.getNumberInputSeparators = _getNumberInputSeparators
Util.calculatePercentage = _calculatePercentage

export default Util
